import { classifyField } from './field-classifier.js';
import { flattenToLegacyContent } from './flatten-legacy.js';
import { migrateContentToV3 } from './content-migrate.js';
/**
 * F-042 — Is this field an operator-keyed INPUT on a single document?
 *
 * The Verification Station keying surface must show ONLY fields a human
 * actually keys/verifies on a document — not every field in the job type.
 * The inclusion criterion is "is this an operator-keyed input on THIS
 * document?" — scope + field-kind, NOT scope alone.
 *
 * Excluded (not keyed on a per-document basis):
 *   - batch-scope fields (`scope: 'batch'`) — declared once per batch at
 *     check-in / batch-fix, never on the per-document VS.
 *   - computed / calculated fields — engine-derived values (e.g. an export
 *     total computed from line items / Q1–Q4), produced by the engine.
 *   - static / constant fields — literal-valued, never keyed.
 *
 * Mirrors the same exclusion class `deriveFieldValidations` uses (computed /
 * static never get auto-validation because they are never keyed). Export-only
 * / derived read-only fields are handled separately by the parse read-only
 * flag and are not classified here.
 */
export function isOperatorKeyedField(field) {
    if (field.scope === 'batch')
        return false;
    const kind = classifyField(field);
    if (kind === 'computed' || kind === 'static')
        return false;
    return true;
}
/**
 * The internalNames of every field in the published content that is NOT an
 * operator-keyed input — i.e. the set the VS document field set must exclude.
 * Pure; `[]`/empty set when content has no fields. Callers match against the
 * `DocumentField.fieldDefinition.internalName` (the same name bridge the parse
 * read-only set uses).
 */
export function nonKeyableFieldNames(content) {
    const flat = flattenToLegacyContent(migrateContentToV3(content));
    const names = new Set();
    for (const field of flat.fields ?? []) {
        if (!isOperatorKeyedField(field))
            names.add(field.name);
    }
    return names;
}
//# sourceMappingURL=keyable-fields.js.map